export const docs = (state = {
  docCache: {},
  currentDocs: [],
  menu_tree: [],
  categories: [],
  tags: [],
  tryingToFetchDocs: false,
  lastQueryString: false,
  lastQueryParams: {},
  pagination: {
    page: 0,
    pages: 0,
    totalDocs: 0
  }
}, action) => {

  switch(action.type){
    // ALL POSTS
    case 'REQUEST_DOCS':

      return {
        ...state,
        currentDocs: [],
        error: undefined,
        docError: undefined,
        tryingToFetchDocs: true
      }

    case 'RECEIVE_DOCS_FAIL':

      return {
        ...state,
        currentDocs: [],
        error: action.data.error,
        docError: undefined,
        lastQueryString: action.data.packet.queryString,
        lastQueryParams: action.data.packet.queryParams || {},
        tryingToFetchDocs: false,
        pagination: {
          page: 0,
          pages: 0,
          totalDocs: 0
        }
      }

    case 'RECEIVE_DOCS_SUCCESS':

      var docCache = state.docCache;
      var currentDocs = [];
      for(let i in action.data.posts){
        docCache[action.data.posts[i].id] = action.data.posts[i];
        currentDocs.push(action.data.posts[i].id);
      }

      return {
        ...state,
        error: undefined,
        docError: undefined,
        docCache: docCache,
        pagination: action.data.pagination,
        currentDocs: currentDocs,
        lastQueryString: action.data.queryString,
        lastQueryParams: action.data.queryParams || {},
        tryingToFetchDocs: false
      }
    
    // SINGLE DOC
    case 'REQUEST_DOC':

      return {
        ...state,
        docError: undefined,
        tryingToFetchDoc: true
      }

    case 'RECEIVE_DOC_FAIL':

      return {
        ...state,
        docError: action.data.error,
        tryingToFetchDoc: false,
        lastQueryString: "",
        lastQueryParams: {},
      }

    case 'RECEIVE_DOC_SUCCESS':

      var docCache = state.docCache;
      docCache[action.data.id] = action.data;
      var currentDocs = [action.data.id];

      return {
        ...state,
        docCache: docCache,
        docError: undefined,
        currentDocs: currentDocs,
        lastQueryString: false,
        lastQueryParams: {},
        currentCategory: false,
        currentTag: false,
        tryingToFetchDoc: false
      }


    // SINGLE DOC BY ID
    case 'REQUEST_DOC_BY_ID':

      return {
        ...state,
        docError: undefined,
        tryingToFetchDoc: true
      }

    case 'RECEIVE_DOC_BY_ID_FAIL':

      return {
        ...state,
        docError: action.data.error,
        tryingToFetchDoc: false,
        lastQueryString: "",
        lastQueryParams: {},
      }

    case 'RECEIVE_DOC_BY_ID_SUCCESS':

      var docCache = state.docCache;
      docCache[action.data.id] = action.data;
      var currentDocs = [action.data.id];

      return {
        ...state,
        docCache: docCache,
        docError: undefined,
        currentDocs: currentDocs,
        lastQueryString: false,
        lastQueryParams: {},
        currentCategory: false,
        currentTag: false,
        tryingToFetchDoc: false
      }
    

    // CATEGORIES
    case 'REQUEST_DOC_CATEGORIES':

      return {
        ...state,
        tryingToFetchCategories: true
      }

    case 'RECEIVE_DOC_CATEGORIES_FAIL':

      return {
        ...state,
        tryingToFetchCategories: false
      }

    case 'RECEIVE_DOC_CATEGORIES_SUCCESS':
      let menu_tree = [];

      let menu_id;
      for(var i in action.data){
        let c = action.data[i];
        if(c.name === 'Menu'){
          menu_id = c.id;
        }
      }

      for(var i in action.data){
        let c = action.data[i];
        if(c.name == 'Docs Home') continue;
        if(c.parent === menu_id){
          c.children = [];
          menu_tree.push(c);
        }
      }

      for(var i in action.data){
        let c = action.data[i];
        for(var j in menu_tree){
          if(c.parent === menu_tree[j].id){
            menu_tree[j].children.push(c);
          }
        }
      }

      menu_tree.sort((a,b)=>{
        // if(a.name == 'Docs Home') return -1;
        // if(b.name == 'Docs Home') return 1;
        if(a.name < b.name) return -1;
        if(a.name > b.name) return 1;
        return 0;
      })
      
      return {
        ...state,
        menu_tree: menu_tree,
        categories: action.data,
        tryingToFetchCategories: false
      }
    
    // TAGS
    case 'REQUEST_DOC_TAGS':

      return {
        ...state,
        tryingToFetchTags: true
      }

    case 'RECEIVE_DOC_TAGS_FAIL':

      return {
        ...state,
        tryingToFetchTags: false
      }

    case 'RECEIVE_DOC_TAGS_SUCCESS':
    
      for(var i in action.data){
        if(action.data[i].count === 0){
          action.data.splice(i, 1);
          i--;
        }
      }
      return {
        ...state,
        tags: action.data,
        tryingToFetchTags: false
      }    
      

    // FEATURED MEDIA
    case 'REQUEST_FEATURED_MEDIA':

      return {
        ...state,
        tryingToFetchFeaturedMedia: true
      }

    case 'RECEIVE_FEATURED_MEDIA_FAIL':

      return {
        ...state,
        tryingToFetchFeaturedMedia: false
      }

    case 'RECEIVE_FEATURED_MEDIA_SUCCESS':
    
      var docCache = state.docCache;
      docCache[action.data.id] = action.data;

      return {
        ...state,
        docCache: docCache,
        tryingToFetchFeaturedMedia: false
      }    
      
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/reducers.docs.js